import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/icon_arrow_top.svg")